import React from 'react';

const BudgetSettingsModal = ({ 
  showBudgetModal, 
  setShowBudgetModal, 
  budget, 
  setBudget, 
  saveBudget 
}) => {
  if (!showBudgetModal) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Budget Settings</h3>
          <button onClick={() => setShowBudgetModal(false)} className="text-gray-400 hover:text-gray-600 text-2xl">×</button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Annual Matching Budget ($)</label>
            <input
              type="number"
              value={budget.annual_budget}
              onChange={(e) => setBudget({...budget, annual_budget: parseInt(e.target.value) || 0})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Default Match Ratio</label>
            <select
              value={budget.match_ratio}
              onChange={(e) => setBudget({...budget, match_ratio: parseFloat(e.target.value)})}
              className="w-full px-4 py-2 border rounded-lg"
            >
              <option value="0.5">0.5:1 (50 cents per dollar)</option>
              <option value="1">1:1 (Dollar for dollar)</option>
              <option value="2">2:1 (Two dollars per dollar)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Max Match Per Employee/Year ($)</label>
            <input
              type="number"
              value={budget.match_cap_per_employee}
              onChange={(e) => setBudget({...budget, match_cap_per_employee: parseInt(e.target.value) || 0})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Auto-Approve Donations Under ($)</label>
            <input
              type="number"
              value={budget.auto_approve_limit}
              onChange={(e) => setBudget({...budget, auto_approve_limit: parseInt(e.target.value) || 0})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            <p className="text-xs text-gray-500 mt-1">Donations under this amount will be automatically approved</p>
          </div>
        </div>
        
        <div className="flex gap-3 mt-6">
          <button onClick={() => setShowBudgetModal(false)} className="flex-1 py-3 border rounded-xl font-medium text-gray-600 hover:bg-gray-50">
            Cancel
          </button>
          <button onClick={saveBudget} className="flex-1 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700">
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default BudgetSettingsModal;
